{
    "InlineExitMessage": "Sind Sie sicher, dass Sie dieses Fenster schließen wollen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
    "InlineExitConfirm": "Bestätigen Sie",
    "InlineExitCancel": "Abbrechen",
    "NotificationsModalTitle": "Benachrichtigungen",
    "TabSettingsTitle": "Einstellungen",
    "TabSettingsDoNotDisturb": "Aktivieren Sie",
    "TabSettingsCME": "CME",
    "TabSettingsTelServer": "Telefonie-Server",
    "TabSettingsPartition": "Teilung \/ Standort",
    "TabSettingsDevices": "Geräte",
    "TabSettingsChannels": "Kanäle",
    "TabSettingsPhoneNumber": "Rufnummer",
    "TabSettingsHeaderGeneral": "Allgemein",
    "TabSettingsHeaderScopeFiltering": "Umfangsfilterung",
    "TabSettingsNotificationChannels": "Benachrichtigungskanäle",
    "TabSetttingsPartitionValidation": "Sie können nur bis zu 5 Partitionen auswählen.",
    "TabPreferencesTitle": "Präferenzen",
    "TabPreferencesHeadingUserNotifications": "Benutzerbenachrichtigungen",
    "IconAddTooltip": "Benachrichtigungen hinzufügen",
    "IconDisabledTooltip": "Benachrichtigungen sind deaktiviert",
    "IconEnabledTooltip": "Benachrichtigungen sind aktiviert",
    "IconDisabled": "Behinderte",
    "NotificationsFooterHelp": "Hilfe",
    "NotificationsFooterCancel": "Abbrechen",
    "NotificationsFooterSubmit": "Speichern Sie",
    "NotificationsFooterValiationWarning": "Bitte korrigieren Sie Fehler vor der Fertigstellung",
    "NotificationPrefereencesThreshholdPlaceholder": "Platzhalter",
    "NotificationPrefereencesThreshholdRequired": "Schwellenwert ist erforderlich",
    "NotificationPrefereencesThreshholdInvalid": "Schwellenwert muss eine Zahl sein",
    "NotificationFooterValidationError": "Validierungsfehler",
    "NAME": "NotificationsLanguageModal"
}